<template>
  <section class="op-footer" v-if="getFourth">
    <div class="footer-content">
      <section class="content__left">
        <ul class="content__right-content">
          <li>
            <h3>联系我们</h3>
            <p v-for="(item, index) in getFourth.value" :key="index">
              {{ item.openTitle }}<span>:</span>{{ item.openDes }}
            </p>
          </li>
        </ul>
      </section>
      <section class="content__right">
        <ul class="content__right-content">
          <li v-for="(item, index) in dataList" :key="index">
            <h3>{{ item.title }}</h3>
            <p v-for="(cell, i) in item.children" :key="i">
              <router-link :to="cell.route">{{ cell.name }}</router-link>
            </p>
          </li>
        </ul>
      </section>
    </div>
    <p class="company-info">
      Copyright © 2019 BAOZUN TIC.及其关联公司All Rights Reserved |
      沪ICP备14583782号-3
    </p>
  </section>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      dataList: [
        {
          title: "文档中心",
          children: [
            {
              name: "API文档",
              route: {
                name: "docApi"
              }
            },
            {
              name: "产品文档",
              route: {
                name: "docProduct"
              }
            },
            {
              name: "技术文档",
              route: {
                name: "docTechnology"
              }
            }
          ]
        },
        {
          title: "平台公告",
          children: [
            {
              name: "产品公告",
              route: {
                name: "docNotice"
              }
            }
          ]
        },
        {
          title: "帮助支持",
          children: [
            {
              name: "常见问题",
              route: {
                name: "docFaq"
              }
            },
            {
              name: "在线测试",
              route: {
                name: "api-test",
                params: {
                  id: "api-test"
                }
              }
            },
            {
              name: "错误查询",
              route: {
                name: "error-code-test",
                params: {
                  id: "error-code-test"
                }
              }
            }
          ]
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      getFourth: "home/getFourth"
    })
  }
};
</script>

<style lang="less">
.op-footer {
  background: @color-default;
  padding: 60px 0px 0px 0px;
  .footer-content {
    width: 1200px;
    margin: 0px auto;
    display: flex;
    justify-content: space-between;
    .content__right,
    .content__left {
      .content__right-content {
        display: flex;
        li {
          margin-left: 60px;
          h3 {
            color: @color-font-white;
            margin-bottom: 32px;
          }
          p {
            margin-bottom: 20px;
            font-size: 16px;
            color: @color-font-label;
            cursor: pointer;
            &:hover {
              color: @color-font-white;
            }
          }
        }
      }
    }
    .content__left {
      .content__right-content {
        li {
          margin-left: 0px;
          p {
            margin-bottom: 12px;
          }
        }
      }
    }
  }
  .company-info {
    margin: 76px 0px 16px 0px;
    text-align: center;
    color: @color-font-label;
  }
}
</style>
